import { gql } from '@apollo/client';

const OUT_BOUND_INFORMATION_FRAGMENT = gql`
  fragment OutboundInformationFragment on OutboundInformation {
    contact {
      name
      street1
      city
      country
      state
      zip
      phone
      email
    }
    labels {
      transaction {
        id
        trackingNumber
        trackingStatus
        labelUrl
        trackingUrlProvider
        eta
      }
      rate {
        id
        carrier
        carrierLogo200
        amount
        serviceLevelName
      }
      shipmentDate
      trackingHistory {
        status
        statusDetails
        statusDate
        location {
          name
          street1
          city
          country
          state
          zip
          phone
          email
        }
      }
      shipmentDevices {
        id
        deviceId
      }
    }
    devices {
      id
      deviceId
      purpose
      device {
        id
        deviceId
        model
      }
      replacedDevice {
        id
        deviceId
      }
      isCompleted
      isRenewal
    }
    latestLabel {
      transaction {
        id
        trackingNumber
        trackingStatus
        labelUrl
        trackingUrlProvider
        eta
      }
      rate {
        id
        carrier
        carrierLogo200
        amount
        serviceLevelName
      }
      shipmentDate
      trackingHistory {
        status
        statusDetails
        statusDate
        location {
          name
          street1
          city
          country
          state
          zip
          phone
          email
        }
      }
      deviceIds
    }
  }
`;

const IN_BOUND_INFORMATION_FRAGMENT = gql`
  fragment InboundInformationFragment on InboundInformation {
    contact {
      name
      street1
      city
      country
      state
      zip
      phone
      email
    }
    labels {
      transaction {
        id
        trackingNumber
        trackingStatus
        labelUrl
        trackingUrlProvider
        eta
      }
      rate {
        id
        carrier
        carrierLogo200
        amount
        serviceLevelName
      }
      shipmentDate
      trackingHistory {
        status
        statusDetails
        statusDate
        location {
          name
          street1
          city
          country
          state
          zip
          phone
          email
        }
      }
      shipmentDevices {
        id
        deviceId
      }
    }
    devices {
      id
      deviceId
      reasons {
        value
        label
        describe
      }
      lostDeviceNeedReplacement
      patientImpact {
        value
        label
        describe
      }
      dateOfEvent
      device {
        id
        deviceId
        model
      }
      replacedDevice {
        id
        deviceId
      }
      isReceived
    }
    latestLabel {
      transaction {
        id
        trackingNumber
        trackingStatus
        labelUrl
        trackingUrlProvider
        eta
      }
      rate {
        id
        carrier
        carrierLogo200
        amount
        serviceLevelName
      }
      shipmentDate
      trackingHistory {
        status
        statusDetails
        statusDate
        location {
          name
          street1
          city
          country
          state
          zip
          phone
          email
        }
      }
      deviceIds
    }
  }
`;

export { OUT_BOUND_INFORMATION_FRAGMENT, IN_BOUND_INFORMATION_FRAGMENT };
